import React from 'react'
import PropTypes from 'prop-types'
import './text.css'

const ImpressumSeite = (props) => {
  return (
    <div className={`text-container ${props.rootClassName}`}>
      <h3 className="text-thq-about-title-elm">Impressum</h3>
      <p className="text-thq-about-text-elm">
        <strong>Name der Organisation:</strong> Stimme Georgiens
        <br /><br />

        <strong>Rechtsform:</strong> Initiative
        <br /><br />

        <strong>Vertretungsberechtigte:</strong> Tornike Svanidze
        <br /><br />

        <strong>Postanschrift:</strong> Kaiser-Joseph-Straße 172, 79098, Freiburg
        <br /><br />

        <strong>Kontakt:</strong>
        <br />
        E-Mail: info@stimmegeorgiens.de
        <br />
        Telefon: +49 176 70910063
        <br /><br />

        <strong>Registereintrag:</strong>
        <br />
        Falls vorhanden: Vereinsregister / Handelsregister, Registergericht, Registernummer
        <br /><br />

        <strong>Haftungshinweis:</strong>
        <br />
        Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung für die Inhalte externer Links. Für den Inhalt der verlinkten Seiten sind ausschließlich deren Betreiber verantwortlich.
        <br /><br />

        <strong>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV:</strong>
        <br />
        Tornike Svanidze
        <br />
        Kaiser-Joseph-Straße 172, 79098, Freiburg
        <br />
      </p>
    </div>
  )
}

ImpressumSeite.defaultProps = {
  rootClassName: '',
}

ImpressumSeite.propTypes = {
  rootClassName: PropTypes.string,
}

export default ImpressumSeite
